import { isTyomarkkinatoriJobSource } from '../job-source/is-tyomarkkinatori-job-source';
import { coerceTypesenseBoolField } from '../typesense/coerce-typesense-bool-field';

/** Official Työmarkkinatori mark used on SRP cards (matches getCompanyLogoDefaultSrc). */
export const TYOMARKKINATORI_LOGO_PATH = '/tyomarkkinatori.svg';

/**
 * TMT ships its wordmark per language (Työmarkkinatori / JobMarket Finland / Jobbmarknaden),
 * copied from tyomarkkinatori.fi/resources/images/. TYOMARKKINATORI_LOGO_PATH stays the canonical
 * marker in data (hit.logoUrl, the mobile app, the MCP widgets); swap it only where it renders.
 */
const TYOMARKKINATORI_LOGO_PATH_BY_LOCALE: Record<string, string> = {
  en: '/tyomarkkinatori-en.svg',
  sv: '/tyomarkkinatori-sv.svg',
};

/** Returns the locale's TMT wordmark when `src` is the canonical mark; any other src unchanged. */
export function localizeTyomarkkinatoriLogoSrc<T extends string | null | undefined>(src: T, locale: string | undefined): T {
  if (src !== TYOMARKKINATORI_LOGO_PATH || !locale) return src;
  return (TYOMARKKINATORI_LOGO_PATH_BY_LOCALE[locale.slice(0, 2).toLowerCase()] ?? src) as T;
}

/**
 * Resolve Työmarkkinatori the same way as Algolia/maintainer: flag or tyomarkkinatori.fi URL.
 */
export function resolveSearchHitIsTyomarkkinatori(hit: Record<string, unknown>): boolean {
  const url = typeof hit.url === 'string' ? hit.url : undefined;
  const flag = coerceTypesenseBoolField(hit.isTyomarkkinatori) ?? hit.isTyomarkkinatori;
  return isTyomarkkinatoriJobSource(url, flag);
}
